// This is the root reducer of the feature. It is used for:
//   1. Load reducers from each action in the feature and process them one by one.
//      Note that this part of code is mainly maintained by Rekit, you usually don't need to edit them.
//   2. Write cross-topic reducers. If a reducer is not bound to some specific action.
//      Then it could be written here.
// Learn more from the introduction of this approach:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da.

import initialState from './initialState';
import { reducer as getFrui_basedataListReducer } from './getFrui_basedataList';
import { reducer as submitFrui_basedataReducer } from './submitFrui_basedata';
import { reducer as deleteFrui_basedataReducer } from './deleteFrui_basedata';
import { reducer as frui_basedataModalChangeReducer } from './frui_basedataModalChange';
import { reducer as chooseCurrentFrui_basedataReducer } from './chooseCurrentFrui_basedata';
import { reducer as getFrui_qpgoodsListReducer } from './getFrui_qpgoodsList';
import { reducer as submitFrui_qpgoodsReducer } from './submitFrui_qpgoods';
import { reducer as deleteFrui_qpgoodsReducer } from './deleteFrui_qpgoods';
import { reducer as frui_qpgoodsModalChangeReducer } from './frui_qpgoodsModalChange';
import { reducer as chooseCurrentFrui_qpgoodsReducer } from './chooseCurrentFrui_qpgoods';
import { reducer as getFrui_planListReducer } from './getFrui_planList';
import { reducer as submitFrui_planReducer } from './submitFrui_plan';
import { reducer as deleteFrui_planReducer } from './deleteFrui_plan';
import { reducer as frui_planModalChangeReducer } from './frui_planModalChange';
import { reducer as chooseCurrentFrui_planReducer } from './chooseCurrentFrui_plan';

const reducers = [
  getFrui_planListReducer,
  submitFrui_planReducer,
  deleteFrui_planReducer,
  frui_planModalChangeReducer,
  chooseCurrentFrui_planReducer,
  getFrui_qpgoodsListReducer,
  submitFrui_qpgoodsReducer,
  deleteFrui_qpgoodsReducer,
  frui_qpgoodsModalChangeReducer,
  chooseCurrentFrui_qpgoodsReducer,
  getFrui_basedataListReducer,
  submitFrui_basedataReducer,
  deleteFrui_basedataReducer,
  frui_basedataModalChangeReducer,
  chooseCurrentFrui_basedataReducer,
];

export default function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    // Handle cross-topic actions here
    default:
      newState = state;
      break;
  }
  return reducers.reduce((s, r) => r(s, action), newState);
}



// WEBPACK FOOTER //
// ./src/features/furui/redux/reducer.js